import React from 'react';

import classnames from 'clsx';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Modal } from 'ui-components/components/modal';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalHeader } from 'ui-components/components/modal/modal-header';

import { RateViewerLoader } from './rate-viewer-loader';
import { RateBrowserShipmentConfigurationPropType } from '../../../prop-types/rate-browser-shipment-configuration';

import style from './rate-viewer-modal.module.less';

export const RateViewerModal = ({ rateViewerKey, onClose, onConfigureLabel, onBrowseRates, onScaleRead, shipmentConfiguration }) => {
  return (
    <Modal className={classnames(style['rate-viewer-modal'])}>
      <ModalHeader closeModal={onClose}>
        <FormattedMessage defaultMessage='Rate Browser' description='rateViewer.title' id='Nc1PvZ' />
      </ModalHeader>
      <ModalBody className={style['rate-viewer-modal-body']}>
        <RateViewerLoader
          onBrowseRates={onBrowseRates}
          onConfigureLabel={onConfigureLabel}
          onScaleRead={onScaleRead}
          rateViewerKey={rateViewerKey}
          shipmentConfiguration={shipmentConfiguration}
        />
      </ModalBody>
    </Modal>
  );
};

RateViewerModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  rateViewerKey: PropTypes.string.isRequired,
  onConfigureLabel: PropTypes.func.isRequired,
  onBrowseRates: PropTypes.func.isRequired,
  onScaleRead: PropTypes.func.isRequired,
  shipmentConfiguration: RateBrowserShipmentConfigurationPropType.isRequired,
};
